import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';
import PopularAccumulators from '@swf/sports/features/PopularAccumulators/PopularAccumulators';
import PopularBetBuilders from '@swf/sports/features/PopularBetBuilders/PopularBetBuilders';

import styles from './SportsHomePageWidget.scss';
import LoadingState from './components/LoadingState/LoadingState';
import { sportsHomePageWidgetModel, useSportsHomePageWidget } from './model';

const WidgetContent = () => {
  const { widgetSelect } = useSportsHomePageWidget();
  const hasPopularBetBuilders = useSelector(widgetSelect.hasPopularBetBuilders);
  const popularBetBuilders = useSelector(widgetSelect.popularBetBuilders);
  const popularAccumulators = useSelector(widgetSelect.popularAccumulators);
  const hasPopularAccumulators = useSelector(widgetSelect.hasPopularAccumulators);

  return (
    <div
      className={classNames({
        [styles.wrapper]: hasPopularBetBuilders || hasPopularAccumulators
      })}
    >
      {hasPopularAccumulators ? (
        <PopularAccumulators popularAccumulators={popularAccumulators} />
      ) : null}
      {hasPopularBetBuilders ? (
        <PopularBetBuilders popularBetBuilders={popularBetBuilders} />
      ) : null}
    </div>
  );
};

const SportsHomePageWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsHomePageWidget();
  const isLoading = useSelector(widgetSelect.isLoading);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const hasErrored = useSelector(widgetSelect.hasErrored);

  if (isLoading && !hasPreloaded) {
    return <LoadingState />;
  }

  if (hasErrored) {
    return null;
  }

  return <WidgetContent />;
};

SportsHomePageWidget.model = sportsHomePageWidgetModel;

export default withWidgetTestId(SportsHomePageWidget, 'sports-home-page');
